<template>
  <b-modal
    v-if="tracks!=null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <h1>{{ Translations.sections.tracks.edition.languages }}</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button
          :empty="false"
          :noBorder="true"
          color="#d2d2d2"
          class="validate"
          @click.prevent="updateTracks"
        >Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input
            type="text"
            v-focus
            maxlength="100"
            placeholder="Search Language"
            v-model="searchData.searchTerm"
          />
      </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingLanguages"></WaitingBlock>
          <template v-else-if="searchResult!=null">
            <div
              v-if="searchResult.dataItem !=null && searchResult.dataItem !=null && searchResult.dataItem.length > 0"
              v-for="language in filteredLanguages"
              :class="['language-container',{'selected' : selectedLanguages[language.code] !== undefined}]"
              @click.prevent="toggleLanguage(language)"
            >
              <i
                :class="['far', selectedLanguages[language.code] === undefined ? 'fa-square':'fa-check-square']"
              ></i>
              <span class="name">
                {{language.code}} -
                <strong>{{language.name}}</strong>
                - ({{language.localName}})
              </span>
            </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No language matching your search criteria</strong>
            </header>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedLanguagesData.length>0">
          <header>{{selectedLanguagesData.length}} selected languages :</header>
          <section>
            <div
              v-for="language in selectedLanguagesData.languages"
              :key="language.code"
              :class="['badge', 'language-badge',{'selected' : selectedLanguages[language.code] === undefined}]"
            >
              <span class="name">{{language.code}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleLanguage(language)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorLanguages",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedLanguagesData() {
      return {
        length: Object.keys(this.selectedLanguages).length,
        languages: Object.values(this.selectedLanguages).sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        })
      };
    },
    filteredLanguages() {
      var str = (this.searchData.searchTerm || "").trim();
      str = this.normalizeSearchTerm(str);
      return (this.searchResult.dataItem || [])
        .filter(language => {
          language.displayOrder = this.languagePriorities[language.code] || 10000000;
          return (
            str == null || str === "" || 
            this.normalizeSearchTerm(language.code).includes(str) ||
            this.normalizeSearchTerm(language.name).includes(str) ||
            this.normalizeSearchTerm(language.localName).includes(str)
          );
        })
        .sort(function (a, b) {
           return a.displayOrder < b.displayOrder ?  -1 : (a.displayOrder > b.displayOrder ? 1 : a.name.localeCompare(b.name));
        });
    }
  },
  mounted() {
    this.search();
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingLanguages: false,
        delayedSearch: null
      },
      languagePriorities:{
        "EN":1,
        "en":1,
        "FR":2,
        "fr":2,
        "ES":3,
        "es":3,
        "DE":4,
        "de":4,
        "NL":5,
        "nl":5,
        "ZH":6,
        "zh":6,
      },
      tracks: [],
      selectedLanguages: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      }
    };
  },
  methods: {
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
      if (this.$refs.inputSearch) {
        this.$refs.inputSearch.focus();
      }
    },
    edit(languages) {
      const langs = languages && languages.reduce((acc, item) => {
        acc[item.code] = item;
        return acc;
      }, {});

      this.selectedLanguages = langs;
      this.show();
    },
    editForTracks(tracks) {
      var tmpLanguages = {};
      this.tracks = tracks;
      if (this.tracks != null && this.tracks.length == 1) {
        for (var i = 0; i < (this.tracks[0].languages || []).length; i++) {
          tmpLanguages[
            this.tracks[0].languages[i].code
          ] = this.tracks[0].languages[i];
        }
      }
      this.selectedLanguages = tmpLanguages;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingLanguages = true;
      try {
        HTTP.get(Apis.parameters.languages)
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingLanguages = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      if (document.activeElement) {
        document.activeElement.blur();
      }
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
      var result = null;

      if (this.noModalEdit) {
        this.cancelModal();
        this.$emit(
          "newValue",
          "languages",
          this.selectedLanguagesData.languages
        );
        return;
      }

      try {
        var data = {
          stationUid: this.stationUid,
          keys: this.trackUids,
          values: this.selectedLanguagesData.languages.map(item => item.code)
        };
        result = await HTTP.post(Apis.library.tracks.update.languages, data);
        if (result.data.dataItem != null) {
          this.tracks.forEach(function(track) {
            if (track == null) return;
            var updatedTrack = result.data.dataItem[track.uid];
            if (updatedTrack === undefined) return;
            track.languages = updatedTrack.languages || [];
            track.warnings = updatedTrack.warnings;
            track.isFilled = updatedTrack.isFilled;
          });
          this.cancelModal();
        }
      } catch (error) {
        result = error.response.data;
      }
      if (result != null && result.errors && result.errors.length === 0) {
        this.cancelModal();
      } else {
        // an error occured : show it
      }
    },
    toggleLanguage(language) {
      language.isSelected = !language.isSelected;
      if (this.selectedLanguages[language.code] != null) {
        Vue.delete(this.selectedLanguages, language.code);
      } else {
        if (!this.multiselect) {
          this.selectedLanguages = {};
        }
        // can't set new value with $set method with a empty object, so create one with the selected language
        if(Object.values(this.selectedLanguages).length === 0){
          this.selectedLanguages = {
            [language.code]: {...language}
          }
        } else {
          // language available so update property oObject with vue $set method
          this.$set(
            this.selectedLanguages,
            language.code,
            Object.assign({ displayOrder: new Date().getTime() }, language)
          );
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.language-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  cursor: pointer;
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
</style>
